import MaterialTable from 'material-table';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

// Reactstrap components
import { Card, CardBody, FormGroup, Input, Row, Col, Form, Button } from "reactstrap";

// style
import { table_translate, table_style } from "../../constants/MaterialTable.js";

// services
import { showMessage } from '../../services/message';
import { api_GET } from '../../services/api_service';
import { formateDate } from "../../helpers/formats";

//Context
import { useAuth } from '../../context/auth';


export default function ConsultaVeiculo() {
    const { setLoading } = useAuth();

    const { register, handleSubmit } = useForm({ mode: "onBlur" });

    const [listVeiculos, setlistVeiculos] = useState([]);

    const onSubmit = (data) => {
        const { cpf_cnpj, placa } = data;

        if (cpf_cnpj.length === 0 && placa.length === 0) {
            showMessage("Aviso", "Preencher pelos menos um filtros", "error", null);
            return;
        }

        const cpfcnpj = cpf_cnpj.length === 0 ? null : cpf_cnpj;
        const placaVeiculo = placa.length === 0 ? null : placa;

        setLoading(true);
        api_GET(`protocoloTransportador/ConsultaVeiculoTransportador/${cpfcnpj}/${placaVeiculo}`).then(result => {
            if (result.data && result.data.length === 0) {
                showMessage("Aviso", "Cadastro não localizado no sistema!", "error", null);
                return;
            }

            // Formatar dataValidadeVistoria para o formato dd/mm/aaaa
            result.data.map(m => {
                m.dataValidadeTransportador = formateDate(m.dataValidadeTransportador)
            })

            setlistVeiculos(result.data);
        })
            .catch(err => showMessage("Aviso", "Não foi localizado nenhum veiculo com dados informados", 'error', null))
            .finally(() => setLoading(false));
    }

    return <>
        <div className='content'>
            <Card className="card-stats">
                <CardBody>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Row className="d-flex align-items-center justify-content-center">
                            <Col md={5} lg={5}>
                                <FormGroup>
                                    <b><label>CNPJ/CPF</label></b>
                                    <Input
                                        type="text"
                                        maxLength="14"
                                        name="cpf_cnpj"
                                        innerRef={register({ required: false })}
                                        defaultValue=""
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={5} lg={5}>
                                <FormGroup>
                                    <b><label>Placa</label></b>
                                    <Input
                                        type="text"
                                        maxLength="14"
                                        name="placa"
                                        innerRef={register({ required: false })}
                                        defaultValue=""
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={2} lg={2}>
                                <FormGroup>
                                    <br />
                                    <Button
                                        color="success"
                                    >
                                        <i className='fas fa-search mr-2'></i>
                                        Pesquisar
                                    </Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                    {listVeiculos.length > 0 &&
                        <Row className="mb-3">
                            <Col md={12}>
                                <MaterialTable style={{ minHeight: "auto" }}
                                    title={`Lista de Veiculos`}
                                    columns={[
                                        { title: 'CNPJ / CPF', field: 'cnpj' },
                                        { title: 'Razão Social', field: 'razaoSocial' },
                                        { title: 'Código Cadastro', field: 'codigoCadastro' },
                                        { title: 'Placa', field: 'placa' },
                                        { title: 'Marca / Modelo', field: 'marcaModelo' },
                                        { title: 'Tipo', field: 'tipo' },
                                        { title: 'Status', field: 'status' },
                                        { title: 'Validade', field: 'dataValidadeTransportador' }
                                    ]}
                                    data={listVeiculos}
                                    isLoading={false}
                                    options={{
                                        filtering: false,
                                        exportButton: true,
                                        table_style
                                    }}
                                    localization={table_translate}
                                />
                            </Col>
                        </Row>
                    }
                </CardBody>
            </Card>
        </div>
    </>;
}